import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MerchantsService } from '../../core/services/merchants.service';
import { Dialog } from '@angular/cdk/dialog';
import { FormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { SubmitBtnComponent } from '../../shared-with-client/submit-btn/submit-btn.component';
import { ToastNotificationsService } from '../../core/services/toast-notifications.service';

@Component({
    selector: 'app-client-loyalty-score',
    templateUrl: './client-loyalty-score.component.html',
    styleUrls: ['./client-loyalty-score.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, SubmitBtnComponent, TranslatePipe],
    standalone: true
})
export class ClientLoyaltyScoreComponent implements OnInit {
  @ViewChild('dialog', {static: true}) scoreDialog: TemplateRef<any>;;
  @Input() clientId: number;
  @Input() clientName: string;
  @Input() bookingId: number;
  @Input() isLoyaltyPrizeBooking: number;

  private toastNotificationsService = inject(ToastNotificationsService);

  public loyaltyStats: any;
  public loading = true;
  public errorMsg = '';
  public saving = false;
  public submitAttempted = false;
  public loyaltyForm: UntypedFormGroup;

  constructor(private merchantService: MerchantsService, private dialog: Dialog, private fb: FormBuilder, private translateService: TranslateService) { }

  ngOnInit(): void {
    if (this.isLoyaltyPrizeBooking) {
      return;
    }
    this.merchantService.getClientLoyaltyStats(this.clientId).subscribe((res) => {
      this.loyaltyStats = res;
      this.loading = false;
      this.setupForm();
    });
  }

  setupForm() {
    if (this.loyaltyStats) {
      this.loyaltyForm = this.fb.group({
        points: [this.loyaltyStats.progress, [Validators.required, Validators.min(0), Validators.max(this.loyaltyStats.visitsNeeded)]],
      });
    }
  }

  openLoyaltyModal() {
    const dialogRef = this.dialog.open<string>(this.scoreDialog, {
      hasBackdrop: true,
    });
  }


  saveScore() {
    this.submitAttempted = true;
    if (!this.loyaltyForm.valid) {
      return;
    }

    this.saving = true;
    const visitsCounterLoyaltyOverride = this.loyaltyForm.get('points').value;
    this.merchantService.updateClient(this.clientId, { visitsCounterLoyaltyOverride }).subscribe((res) => {
      this.saving = false;
      this.loyaltyStats.progress = visitsCounterLoyaltyOverride;
      this.toastNotificationsService.showToast(this.translateService.instant('GENERAL.savedSuccessfully'), 'success');
      this.dialog.closeAll();
    }, err => {
      this.errorMsg = this.translateService.instant('GENERAL.generalErrorMsg');
      this.toastNotificationsService.showToast(this.errorMsg, 'error');
      this.saving = false;
      this.dialog.closeAll();
    });
  }

  close() {
    this.dialog.closeAll();
  }

}
